import script from "./LayoutLeftSide.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutLeftSide.vue?vue&type=script&setup=true&lang=ts"

import "./LayoutLeftSide.vue?vue&type=style&index=0&id=7afe7144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7afe7144"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QScrollArea,QAvatar,QSeparator,QList,QItemLabel,QItem});
